var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4403_78888)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4403_78888)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#paint0_linear_4403_78888)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1415 6.98138C11.1415 7.47313 11.4108 7.67685 11.666 7.69828V8.30945C11.4108 8.33052 11.1415 8.52687 11.1415 9.03337V9.69336C11.1415 10.614 10.666 11 9.94808 11H9.66602V10.2975H9.82429C10.1071 10.2975 10.3005 10.0938 10.3005 9.71444V8.92062C10.3005 8.38672 10.5691 8.09168 10.8243 8.01405V8C10.5622 7.91605 10.3005 7.62768 10.3005 7.10081V6.45451C10.3005 5.96242 10.1898 5.70952 9.82429 5.70952H9.66602V5H9.94808C10.6384 5 11.1415 5.37935 11.1415 6.29996V6.98138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85264 9.01873C4.85264 8.52702 4.58245 8.3233 4.33301 8.30223V7.6911C4.58245 7.67002 4.85264 7.47334 4.85264 6.96722V6.30691C4.85264 5.38635 5.33699 5 6.04932 5H6.33301V5.70948H6.17421C5.8836 5.70948 5.69644 5.90652 5.69644 6.28584V7.07961C5.69644 7.61383 5.43386 7.90886 5.1775 7.98613V8.00018C5.44043 8.08447 5.69644 8.37248 5.69644 8.89932V9.54557C5.69644 10.0373 5.81407 10.2905 6.17421 10.2905H6.33301V11H6.04932C5.3574 11 4.85264 10.6207 4.85264 9.70046V9.01873Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "black",
    strokeOpacity: 0.08
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4403_78888",
    x1: -8,
    y1: 8,
    x2: 8,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62C3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14952,
    stopColor: "#61C1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285789,
    stopColor: "#5FBBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41037,
    stopColor: "#5BB3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524829,
    stopColor: "#57A7DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630727,
    stopColor: "#5299D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72963,
    stopColor: "#4C89D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#4578D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912702,
    stopColor: "#3F65D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3952D3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4403_78888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4403_78888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.5a2f3b0e3b76279ea7406c4e704c1427.svg";
export { ForwardRef as ReactComponent };